
import VhallPaasSDK from '../sdk/index.js'

export function loaded(sdk) {
  return function decorator(t, n, descriptor) {
    const original = descriptor.value;
    descriptor.value = async function (...args) {
      await VhallPaasSDK.loadjs(sdk)
      return original.apply(this, args)
    }
  }
}
//当前方法只能执行一次
export function once(target, key, descriptor) {
  const originalMethod = descriptor.value;
  let hasExecuted = false;

  descriptor.value = function (...args) {
    if (!hasExecuted) {
      hasExecuted = true;
      return originalMethod.apply(this, args);
    } else {
      console.log("This method can only be executed once.");
    }
  };
  return descriptor;
}